module.exports = __webpack_public_path__ + "static/media/portfolio-img3.91f85a2b.jpg";